const TokenService = {
  setToken: (token: string) => {
    sessionStorage.setItem("pepper-pay-token", token.replace(/[+]/gi,'%2b'));
  },
  getToken: () => {
    return sessionStorage.getItem("pepper-pay-token");
  },
  clearToken: () => {
    sessionStorage.removeItem("pepper-pay-token");
  },
  setLeadToken: (token: string) => {
    sessionStorage.setItem("lead_token", token.replace(/[+]/gi,'%2b'));
  },
  getLeadToken: () => {
    return sessionStorage.getItem("lead_token");
  },
  clearLeadToken: () => {
    sessionStorage.removeItem("lead_token");
  },
  clearSession: () => {
    sessionStorage.clear();
  },
};

export default TokenService;
